<div class="filter-for-list">
  <h3 class="alarm-project-name">{{'PROJECTS_MAP_TITLE' | translate}}</h3>
  <button *ngIf="readOnly" (click)="switchView()" type="button" class="btn top-list-tools" placement="left">
    <fa-icon [icon]="iconService.faExchangeAlt" style="margin-right: 10px"></fa-icon>
    <span>{{'PROJECTS_SWITCH_MAP_PLAN' | translate}}</span>
  </button>
  <app-project-sub-menu></app-project-sub-menu>
  <br clear="both"/>
  <br clear="both"/>
</div>
<app-progressbar *ngIf="showSpinner"></app-progressbar>

<div style="display: flex" *ngIf="!showSpinner">


  <div *ngIf="selectedView === 1" id="mapCont" [ngStyle]="{opacity: mapOpacity}" class="mainViewContMap">
    <agm-map [mapTypeId]="'hybrid'" [latitude]="mapCenter.lat"
             [longitude]="mapCenter.lng"
             [fitBounds]="fitBounds"
             (centerChange)="setMapCenter($event)"
             style="height: 100%">
      <agm-map-type-control></agm-map-type-control>
      <agm-marker *ngFor="let marker of markers"
                  [latitude]="marker.latitude"
                  [longitude]="marker.longitude"
                  [label]="(marker.note_litteral && !marker.disabled && marker?.device_type?.type !== 'pt_v5') ? marker.note_litteral : ''"
                  [iconUrl]="marker.icon_url"
                  [agmFitBounds]="true"
                  [markerDraggable]="readOnly ? false : true"
                  (markerClick)="goToChart(marker)"
                  (dragEnd)="readOnly ? '' : patchProjectDeviceLocation($event, marker)"
                  (markerClick)="readOnly ? '' : toggleSelectedMarker($event, marker.id, marker.selected ? 'unselect' : 'select')"
                  (mouseOver)="marker.infoWindow = true"
                  (mouseOut)="marker.infoWindow = false"
                  [ngClass]="marker.disabled ? 'disabled' : ''">
        <agm-info-window
          [disableAutoPan]="true"
          [isOpen]="marker.infoWindow">
          <b style="font-weight: 500"> {{marker.name}}</b>
        </agm-info-window>
      </agm-marker>
    </agm-map>
  </div>

  <div *ngIf="selectedView === 2" class="mainViewCont">
    <div id="thumbnailCont">
      <div class="thumbnail"
           (click)="switchToMap()"
           [ngbTooltip]="'PROJECTS_BACK_TO_MAP' | translate" placement="bottom">
        <div class="thumbnailImgCont">
          <img src="assets/images/logos/mapLogo.jpg">
        </div>
        <div class="thumbnailTitle">
          {{'PROJECTS_BACK_TO_MAP' | translate}}
        </div>
      </div>
      <div *ngFor="let plan of plans; let i = index;"
           class="thumbnail"
           (click)="switchToPlan(i)"
           [ngbTooltip]="'TOOL_GOTO_PLAN' | translate" placement="bottom">
        <div class="thumbnailImgCont">
          <img [src]="plan.url">
        </div>
        <div class="thumbnailTitle">
          {{plan.name}}
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="selectedView === 3" id="planCont" class="mainViewCont">
    <div id="planSubCont"
         #plan
         *ngIf="plans && plans[selectedPlanIndex]">
      <img class="planLarge" [src]="plans[selectedPlanIndex].url">
      <div id="markersCont" style="left:0">
        <div *ngFor="let location of plans[selectedPlanIndex].location_plans"
             [ngStyle]="{top: location.pos_y + '%', left: location.pos_x + '%'}"
             class="marker label"
             [ngbTooltip]="location.name">
          <img [src]="location.icon_url">
          <span>{{location?.device_type?.type !== 'pt_v5' ? location.note_litteral : ''}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="listCont">
    <div *ngFor="let marker of markers; let i = index"
         class="location flexCenter labelsCont"
         (click)="readOnly ? goToChart(marker) : toggleSelectedMarker(marker, marker.id, marker.selected ? 'unselect' : 'select')"
         [ngClass]="{locationSelected: marker.selected, childMarker: marker.parent, odd: (i % 2 === 0)}"
         style="cursor:pointer">

      <div class="labelCont">
        <div class="label">
          <img [src]="marker.icon_url">
          <span>{{marker?.device_type?.type !== 'pt_v5' ? marker.note_litteral : ''}}</span>
        </div>
        <div>{{marker.name}}</div>
      </div>

      <div *ngIf="!readOnly">
        <fa-icon *ngIf="marker.selected" (click)="deleteProjectDeviceLocation(marker)"
                 class="closeButton"
                 [icon]="iconService.faTimes"></fa-icon>
        <div *ngIf="!marker.selected">
          <fa-icon *ngIf="marker.latitude && marker.longitude; else notLocated"
                   [icon]="iconService.faCheckCircle" style="color: #3eb6e9; font-size: 15px"></fa-icon>
          <ng-template #notLocated>
            <!--tooltip -->
            <fa-icon *ngIf="(!marker.latitude) || (!marker.longitude)"
                     (click)="addMarkerToMap(marker)"
                     [icon]="iconService.faPlusCircle"
                     style="color: #337ab7; cursor: pointer; font-size: 15px"></fa-icon>
          </ng-template>
        </div>
      </div>

    </div>
  </div>
</div>
<div class="filter-for-list" *ngIf="!readOnly"><br clear="both"/><br clear="both"/></div>
